<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Pre-approved" subtitle="Manage the badge holders you have pre-approved for volunteer slots." :readonly="$authorised('con/volunteers/access', 'read')">

		<app-content-head-actions-item text="Add" icon="add" v-on:click="onCreateClick" tooltip="Add pre-approved badge" />

		<app-content-head-actions-panel text="Export" icon="export" component="manager/common/panel/Export" :data="importexportData" :disabled="!collection.length" />

	</app-content-head>

	<app-content-filters :changed="isFilterDirty" v-on:reset="onResetFilter">

		<app-content-filters-search v-model="filter.search" />

	</app-content-filters>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no badge holders found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column /> 

				<app-table-column text="Badge" /> 

				<app-table-column text="Eligible Roles" />

				<app-table-column align="center" text="Approved on" />

				<app-table-column align="center" text="Assignments" />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.volunteers.approval.statusName[item.status]" :subtext="item.reference" :type="$constants.volunteers.approval.statusTheme[item.status]" />

					<app-table-cell-item type="convention/badge" :item="item.badge" />

					<app-table-cell-labels align="left" :labels="labels(item)" />

					<app-table-cell-text align="center" :text="item.date | localDate('MM/DD/YYYY')" :can-empty="true" />

					<app-table-cell-text align="center" :text="item.count.assignments" />

				</app-table-row>

			</app-table-body>

			<app-table-foot :pagination="pagination" :total="total" />

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			references: {
				roles: []
			},	
			layout: '120px 320px 1fr 115px 115px',
			endpoint: 'convention/volunteers/approvals',
			live: 'convention/volunteers/approvals'
		}

	},

	computed: {

		importexportData: function() {

			return {
				columns: {
					status: 'Status',
					reference: 'Reference',
					badgeReference: 'Badge Reference',
					badgeFirstName: 'First Name',
					badgeLastName: 'Last Name',
					badgeEmail: 'E-mail',
					eligibility: 'Eligibility',
					allowlist: 'Allow List',
					blocklist: 'Block List'
				},
				requiredColumns: [],
				valueMapping: [],
				params: {},
				index: this.selectedIndex,
				endpoint: this.$endpoint(this.endpoint)
			}

		}
	
	},

	methods: {
	
		labels: function(item) {
		
			var labels = []

			if(item.type === this.$constants.volunteers.whitelist.type.all || (item.type === this.$constants.volunteers.whitelist.type.blacklist && !item.roles.length)) {
				
				labels.push({
					text: 'All',
					type: 'green'				
				})
			
			} else if(item.type === this.$constants.volunteers.whitelist.type.whitelist && !item.roles.length) {
				
				labels.push({
					text: 'All',
					type: 'red'				
				})
			
			} else {

				this.$_.each(item.roles, function(role) {
				
					labels.push({
						text: ((item.type === this.$constants.volunteers.whitelist.type.whitelist) ? '+ ' : '- ') + this.$_.findWhere(this.references.roles, { id: role }).name,
						type: (item.type === this.$constants.volunteers.whitelist.type.whitelist) ? 'green' : 'red'					
					})

				}.bind(this))	
			}

			return labels
		
		}

	}

}

</script>

<style scoped>

</style>